import {
  normalizeConversationSourceFilter,
  type ConversationSourceFilter,
} from "@/types/conversationSource"

export function normalizeHumanReviewSourceFilter(value: { source?: unknown }): {
  source?: ConversationSourceFilter
} {
  if (!("source" in value)) {
    return {}
  }

  const source = normalizeConversationSourceFilter(value.source)
  if (!source) {
    throw new Error("human_review_view: filters.source is invalid")
  }
  return source === "all" ? {} : { source }
}
